import { render } from "./EditBAST.vue?vue&type=template&id=544d2587&scoped=true"
import script from "./EditBAST.vue?vue&type=script&lang=js"
export * from "./EditBAST.vue?vue&type=script&lang=js"

import "./EditBAST.vue?vue&type=style&index=0&id=544d2587&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544d2587"]])

export default __exports__